// extracted by mini-css-extract-plugin
export default {"p_content":"_3a516f5428"};